<template>
  <div class="mt-2 maximize">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d947.3587852282643!2d21.0760988093028!3d46.66213103537314!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47442c766608b2bf%3A0x98c37c41f7a4030c!2zQsOpa8Opc2NzYWJhLCBPcm9zaMOhemkgdXRjYSAzMiwgNTYwMCBNYWd5YXJvcnN6w6Fn!5e0!3m2!1shu!2sus!4v1551182560134"
      height="500"
      width="100%"
      frameborder="0"
      allowfullscreen
      class="mt-2"
    />

    <div
      class="pacifico mt-5 primary--text text-xs-center"
      style="font-size: 26px;"
    >
      Felkeltettük érdeklődését?
    </div>

    <div
      id="elerhetoseg"
      class="mt-2 font-weight-bold display-2 text-xs-center"
      style="color: #212121;"
    >
      Kapcsolat
    </div>

    <VLayout
      wrap
      class="mt-5"
    >
      <VFlex
        xs12
        sm12
        md6
      >
        <VCard
          class="ma-2"
          style="height: calc(100% - 16px);"
        >
          <VCardTitle class="headline">
            Elérhetőség és céginformáció
          </VCardTitle>

          <VCardText>
            <div
              class="pacifico primary--text text-xs-center"
              style="font-size: 18px;"
            >
              E-mail címünk
            </div>

            <VChip
              label
              outline
              disabled
              class="chip mx-0"
            >
              <VIcon
                class="mr-1"
                style="user-select: none;"
              >
                email
              </VIcon>

              <a
                class="subheading"
                href="mailto:info@print-pack.hu"
              >
                info@print-pack.hu
              </a>
            </VChip>

            <div class="mb-3 mt-5 subheading">
              <b>
                Körös PRINT-PACK Nyomdaipari Csomagolástechnikai Kft.
              </b>
            </div>

            <div class="mb-3 subheading">
              <b>Adószám:</b> 10264175-2-04
            </div>

            <div class="mb-3 subheading">
              <b>Cégjegyzékszám:</b> 04-09-001059
            </div>

            <div class="mb-3 subheading">
              <b>H-5600 Békéscsaba, Orosházi út 32.</b>
            </div>
          </VCardText>
        </VCard>
      </VFlex>

      <VFlex
        xs12
        sm12
        md6
      >
        <VCard
          v-for="(contact, index) in contacts"
          :key="index"
          class="ma-2"
        >
          <VCardTitle>
            <div
              class="text-xs-center"
              style="width: 100%;"
            >
              <div
                class="pacifico primary--text text-xs-center"
                style="font-size: 18px;"
              >
                {{ contact.title }}
              </div>

              <div
                class="title mt-2 font-weight-bold display-2 text-xs-center"
              >
                {{ contact.name }}
              </div>

              <VChip
                label
                outline
                disabled
                class="chip mx-0"
              >
                <VIcon
                  class="mr-1"
                >
                  phone
                </VIcon>

                <a
                  class="subheading"
                  :href="`tel:${contact.phone}`"
                >
                  <span>{{ contact.phone }}</span>
                </a>
              </VChip>

              <VChip
                label
                outline
                disabled
                class="chip mx-0"
              >
                <VIcon
                  class="mr-1"
                  style="user-select: none;"
                >
                  email
                </VIcon>

                <a
                  class="subheading emailText"
                  :href="`mailto:${contact.email}`"
                >
                  {{ contact.email }}
                </a>
              </VChip>
            </div>
          </VCardTitle>
        </VCard>
      </VFlex>
    </VLayout>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  metaInfo: {
    title: 'Rólunk | Körös PRINT-PACK Kft.',
    meta: [
      {
        name: 'description',
        content: 'Vegye fel velünk a kapcsolatot telefonon +3666328570 vagy az info@print-pack.hu e-mail címen.',
      },
    ],
  },
  data: () => ({
    contacts: [
      {
        title: 'Marketing vezető',
        name: 'Zalánfi Sándor',
        phone: '+36309423252',
        email: 'zalanfisandor@print-pack.hu',
      },
      {
        title: 'Marketing menedzser',
        name: 'Plavecz Arabella',
        phone: '+36307248309',
        email: 'plaveczarabella@print-pack.hu',
      },
      {
        title: 'Üzletfejlesztési vezető',
        name: 'ifj. Tóth János',
        phone: '+36308233679',
        email: 't.janos@print-pack.hu',
      },
    ],
  }),
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.chip {
  width: 100%;
  height: 40px !important;
}

.chip >>> .v-chip__content {
  margin: auto;
  height: 40px;
}

.chip:hover {
  background-color: rgb(40, 53, 147, 0.3) !important;
}

@media (max-width: 959px) {
  .emailText {
    font-size: 14px !important;
  }
}
</style>
